import { ofType } from "redux-observable";
import { mergeMap } from "rxjs/operators";
import { merge, of } from "rxjs";

import { GET_LAST_SCORE_CARD } from "../types/scoreCardTypes";
import {
  getLastScoreCardFulfilled,
  getLastScoreCardPending,
  getLastScoreCardRejected,
} from "../actions/getLastScoreCardActions";
import { sendApiRequest } from "../../../actions/apiRequestActions";
import { notifyError } from "../../../actions";
import generateError from "../../../utilities/generateError";

const getLastValidScoreCard = (payload) => ({
  method: "get",
  url: "scorecard/all",
  amlJava: true,
  onSuccess: [getLastScoreCardFulfilled],
  onError: [
    getLastScoreCardRejected,
    (error) => notifyError(generateError(error)),
  ],
  data: payload,
});

const meta = {
  api: "ajaxApi",
};

const getLastScoreCardEpic$ = (action$) =>
  action$.pipe(
    ofType(GET_LAST_SCORE_CARD.DEFAULT),
    mergeMap(({ payload }) =>
      merge(
        of(getLastScoreCardPending()),
        of(sendApiRequest(getLastValidScoreCard(payload), meta))
      )
    )
  );

export default getLastScoreCardEpic$;



// WEBPACK FOOTER //
// ./src/features/score-card/epics/getLastScoreCardEpic.js